import createIcon from '../../createIcon';

/**
 * @component @name VideoLabel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxOUMxIDIwLjEgMS45IDIxIDMgMjFIMjFDMjIuMSAyMSAyMyAyMC4xIDIzIDE5VjVDMjMgMy45IDIyLjEgMyAyMSAzWk0yMSAxNkgzVjVIMjFWMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideoLabel = createIcon('VideoLabel', [
  [
    'path',
    {
      d: 'M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 16H3V5H21V16Z',
      key: 'o9q5u',
    },
  ],
]);

export default VideoLabel;
